import { Path } from 'pages/Map/MyMap/Map/components/ZoneMap/components/Path';
import { Region, StationType, Zone } from 'pages/Map/types';

const updateInDirectPaths = (zone: Zone, path: Path) => {
    const updatedPath = zone.paths?.some(pathObj => {
        //updates direct path in the zone
        if (path.source.id === pathObj.start.id && path.target.id === pathObj.end.id) {
            return (pathObj.isSelected = path.isSelected);
        }
    });

    return updatedPath;
};

const updateZoneWithPath = (zone: Zone, path: Path) => {
    const isPathUpdated = updateInDirectPaths(zone, path);

    if (!isPathUpdated) {
        //updates path inside subzone
        const subZones = zone.stations.filter(({ type }) => type === StationType.SubZone);
        subZones.some(({ zone }) => zone && updateInDirectPaths(zone, path));
    }
    return zone;
};

export const updateWithPath = (zones: Zone[], zoneName: string, path: Path) => {
    const zone = zones.find(({ name }) => name === zoneName);
    if (!zone) {
        return;
    }

    return updateZoneWithPath(zone, path);
};

export const getZoneIndex = (region: Region, zone?: string) => {
    return region.zones.findIndex(({ name }: Zone) => name === zone);
};
